<script>
  export let toast;
</script>

<div class="toast" id="toast-{toast.id}">
  <img class="toast-img" src={toast.image || "/img/preview-product-3.png"} alt="notification" />

  <button class="toast-content" style="width: 100%;height: 100%; display: flex; flex-direction: column; font-size:1rem;overflow:hidden; ">
    <div style="width:100%;">
      <h3 class="title">{toast.title || "Product title"}</h3>
      <p class="subtitle">{toast.subtitle || ""}</p>
      <p class="body">{toast.body || ""}</p>
    </div>
  </button>

  <button class="close-btn">
    <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg" class="h-4 w-4">
      <path
        d="M11.7816 4.03157C12.0062 3.80702 12.0062 3.44295 11.7816 3.2184C11.5571 2.99385 11.193 2.99385 10.9685 3.2184L7.50005 6.68682L4.03164 3.2184C3.80708 2.99385 3.44301 2.99385 3.21846 3.2184C2.99391 3.44295 2.99391 3.80702 3.21846 4.03157L6.68688 7.49999L3.21846 10.9684C2.99391 11.193 2.99391 11.557 3.21846 11.7816C3.44301 12.0061 3.80708 12.0061 4.03164 11.7816L7.50005 8.31316L10.9685 11.7816C11.193 12.0061 11.5571 12.0061 11.7816 11.7816C12.0062 11.557 12.0062 11.193 11.7816 10.9684L8.31322 7.49999L11.7816 4.03157Z"
        fill="currentColor"
        fill-rule="evenodd"
        clip-rule="evenodd"
      ></path>
    </svg>
  </button>
</div>

<style>
  * {
    margin: 0;
    text-decoration: none;
    box-sizing: border-box;
    font-family:
      ui-sans-serif,
      system-ui,
      sans-serif,
      Apple Color Emoji,
      Segoe UI Emoji,
      Segoe UI Symbol,
      Noto Color Emoji;
  }

  .toast .close-btn {
    position: absolute;
    top: 2px;
    right: 2px;
    padding: 4px;
  }
  .toast:hover .close-btn,
  .toast.expanded .close-btn {
    opacity: 1 !important;
  }

  .toast a {
    color: inherit;
  }
  .title {
    font-size: 16px;
    margin-bottom: 4px;
    font-weight: 700;
  }
  .subtitle {
    font-size: 15px;
  }
  .body {
    font-size: 13px;
  }
  .toast button {
    background-color: transparent;
    border: none;
    cursor: pointer;
    text-align: inherit;
    color: inherit;
  }
  .toast h3 {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    width: 160px;
  }
  .toast {
    position: absolute;
    top: 0;
    left: 100%;
    margin: 1em 0 0 1em;
    overflow: hidden;
    width: 260px;
    display: grid;
    grid-template-columns: 54px 1fr;
    align-items: start;
    gap: 0.75rem;
    padding: 12px;
    padding-right: 24px;
    background-color: #fff;
    backdrop-filter: blur(8px);
    -webkit-backdrop-filter: blur(8px);
    border: 1px solid rgb(228, 228, 231);
    box-shadow:
      0 4px 6px -1px rgb(0 0 0 / 0.1),
      0 2px 4px -2px rgb(0 0 0 / 0.1);
    border-radius: 10px;
    font-size: 1rem;
    line-height: 1.5rem;
    z-index: 50;
    color: hsl(0, 0%, 12%);
    text-align: left;
    overflow: hidden;
    user-select: auto;
    pointer-events: auto;
  }

  @media (min-width: 640px) {
    .toast {
      max-width: 350px;
    }
  }

  .toast img {
    width: 54px;
    height: 54px;
    aspect-ratio: 1/1;
    object-fit: contain;
    border-radius: 4px;
    overflow: hidden;
  }
  @keyframes slideIn {
    from {
      transform: translateX(10%);
    }
    to {
      transform: translateX(0);
    }
  }
  @keyframes fadeOut {
    from {
      opacity: 1;
    }
    to {
      opacity: 0;
    }
  }
</style>
